/* CEREMONIES */
export const GET_CEREMONIES = "GET_CEREMONIES"
export const GET_CEREMONIES_SUCCESS = "GET_CEREMONIES_SUCCESS"
export const GET_CEREMONIES_FAIL = "GET_CEREMONIES_FAIL"

/* CEREMONIES PROFILE */
export const GET_CEREMONY_PROFILE = "GET_CEREMONY_PROFILE"
export const GET_CEREMONY_PROFILE_SUCCESS = "GET_CEREMONY_PROFILE_SUCCESS"
export const GET_CEREMONY_PROFILE_FAIL = "GET_CEREMONY_PROFILE_FAIL"

/**
 * add CEREMONY
 */
 export const ADD_NEW_CEREMONY = "ADD_NEW_CEREMONY"
 export const ADD_CEREMONY_SUCCESS = "ADD_CEREMONY_SUCCESS"
 export const ADD_CEREMONY_FAIL = "ADD_CEREMONY_FAIL"

 /**
 * Edit CEREMONY
 */
export const UPDATE_CEREMONY = "UPDATE_CEREMONY"
export const UPDATE_CEREMONY_SUCCESS = "UPDATE_CEREMONY_SUCCESS"
export const UPDATE_CEREMONY_FAIL = "UPDATE_CEREMONY_FAIL"

/**
 * Delete CEREMONY
 */
export const DELETE_CEREMONY = "DELETE_CEREMONY"
export const DELETE_CEREMONY_SUCCESS = "DELETE_CEREMONY_SUCCESS"
export const DELETE_CEREMONY_FAIL = "DELETE_CEREMONY_FAIL"


